<template>
    <div class="fab" id="fab" v-show="unreadMessages.length">
        <div class="msg-button" :class="{'not-move': !flag}" ref="button">
            <img src="@/assets/img/chat.svg">
            <div class="count">
                {{ unreadMessages.length }}
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "FloatingActionButton",
        data() {
            return {
                flag: false,
                position: { x: 0, y: 0 },
                nx: "",
                ny: "",
                dx: "",
                dy: "",
                xPum: "",
                yPum: "",
                x: "",
                y: "",
                firstTime: null,
            }
        },
        computed: {
            ...mapGetters(['unreadMessages'])
        },
        mounted() {
            let moveDiv = document.querySelector("#fab");
            this.w = this.$parent.$refs.pageContent.clientWidth;
            this.h = this.$parent.$refs.pageContent.clientHeight;
            this.x = moveDiv.offsetWidth;
            this.y = moveDiv.offsetHeight;
            moveDiv.addEventListener("touchstart", this.down, { passive: false });
            moveDiv.addEventListener("touchmove", this.move, { passive: false });
            document.addEventListener("mousemove", this.move, { passive: false });
            moveDiv.addEventListener("mousedown", this.down, { passive: false });
            document.addEventListener("mouseup", this.end, { passive: false });
            moveDiv.addEventListener("mouseup", this.end, { passive: false });
            moveDiv.addEventListener("touchend", this.end, { passive: false });
        },
        methods: {
            down(event) {
                let moveDiv = document.querySelector("#fab");
                let touch;
                this.flag = true;
                if (event.touches) {
                    touch = event.touches[0];
                } else {
                    touch = event;
                }
                this.position.x = touch.clientX;
                this.position.y = touch.clientY;
                this.dx = moveDiv.offsetLeft;
                this.dy = moveDiv.offsetTop;
                this.firstTime = new Date().getTime();
            },
            move(event) {
                if (this.flag) {
                    let moveDiv = document.querySelector("#fab");
                    let touch;
                    if (event.touches) {
                        touch = event.touches[0];
                    } else {
                        touch = event;
                    }

                    event.preventDefault();
                    this.nx = touch.clientX - this.position.x;
                    this.ny = touch.clientY - this.position.y;
                    this.xPum = this.dx + this.nx;
                    this.yPum = this.dy + this.ny;

                    this.xPum = this.xPum > 0 ? this.xPum : 0;
                    this.yPum = this.yPum > 0 ? this.yPum : 0;
                    this.xPum = this.xPum > this.w - this.x ? this.w - this.x : this.xPum;
                    this.yPum = this.yPum > this.h - this.y ? this.h - this.y : this.yPum;


                    moveDiv.style.right = this.w - this.xPum - this.$refs.button.clientWidth + "px";
                    moveDiv.style.top = this.yPum + "px";
                }
            },
            end() {
                this.flag = false;
                this.lastTime = new Date().getTime();
                if (this.lastTime - this.firstTime < 200) {
                   this.onClick();
                } else {
                    let moveDiv = document.querySelector("#fab");
                    moveDiv.style.right = "30px";
                }
            },
            onClick() {
                if (this.unreadMessages.length === 1) {
                    this.$router.push({
                        name: 'message',
                        params: {
                            id: this.unreadMessages[0]['messageable_id'],
                        }
                    })
                } else if (this.unreadMessages.length > 1) {
                    this.$router.push({
                        name: 'orders'
                    })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .fab {
        position: absolute;
        top: 30px;
        right: 30px;
        user-select: none;
        cursor: pointer;
        z-index: 99999;
        transition: .3s;

        .msg-button {
            width: 48px;
            height: 48px;
            border-radius: 90px;
            background-color: #DDDDDD;
            box-shadow: 0 3px 5px 0 rgba(0,0,0,0.25);
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            .count {
                position: absolute;
                width: 21px;
                height: 21px;
                color: #FFFFFF;
                background-color: #F44336;
                border: 1px solid #DDDDDD;
                box-sizing: border-box;
                border-radius: 90px;
                display: flex;
                justify-content: center;
                align-items: center;
                right: 0;
                top: 0;
                font-size: 12px;
                font-weight: 600;
            }
        }
    }
</style>